module.exports = __webpack_public_path__ + "static/media/blue_arrow.79642f96.svg";